/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuoteStatus = {
    Draft: 'DRAFT',
    PendingCompliance: 'PENDING_COMPLIANCE',
    Submitted: 'SUBMITTED',
    Canceled: 'CANCELED',
    Accepted: 'ACCEPTED',
    Expired: 'EXPIRED',
    AcceptanceBlocked: 'ACCEPTANCE_BLOCKED'
} as const;
export type QuoteStatus = typeof QuoteStatus[keyof typeof QuoteStatus];


export function instanceOfQuoteStatus(value: any): boolean {
    for (const key in QuoteStatus) {
        if (Object.prototype.hasOwnProperty.call(QuoteStatus, key)) {
            // @ts-ignore
            if (QuoteStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteStatusFromJSON(json: any): QuoteStatus {
    return QuoteStatusFromJSONTyped(json, false);
}

export function QuoteStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteStatus {
    return json as QuoteStatus;
}

export function QuoteStatusToJSON(value?: QuoteStatus | null): any {
    return value as any;
}

